<template>
	<div class="content-wrapper">
		<div class="container flex-grow-1 container-p-y">

			<div class="d-flex flex-column justify-content-center mb-6">
				<h4 class="mb-1">{{ $t('settings.userPageTitle') }}</h4>
				<p class="mb-0">{{ $t('settings.userPageDescription') }}</p>
			</div>

			<!-- Profil -->
			<div class="card mb-6">
				<h5 class="card-header">{{ $t('settings.accountTitle') }}</h5>
				<div class="card-body pt-1" v-if="profile">
					<form id="formAccountSettings" method="GET" onsubmit="return false">
						<div class="row g-5 mb-2">
							<div class="col-md-6">
								<div class="form-floating form-floating-outline">
									<input class="form-control" type="text" v-model="profile.firstName" disabled />
									<label>{{ $t('common.fields.firstName') }}</label>
								</div>
							</div>

							<div class="col-md-6">
								<div class="form-floating form-floating-outline">
									<input class="form-control" type="text" v-model="profile.lastName" disabled />
									<label>{{ $t('common.fields.lastName') }}</label>
								</div>
							</div>

							<div class="col-md-12">
								<div class="form-floating form-floating-outline">
									<input class="form-control" type="text" v-model="profile.email" disabled />
									<label>{{ $t('common.fields.email') }}</label>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>

			<!-- Mot de passe -->
			<div class="card mb-6">
				<h5 class="card-header">{{ $t('settings.changePassword') }}</h5>
				<div class="card-body pt-1">
					<form id="formPasswordSettings" method="GET" onsubmit="return false">
						<div class="row g-5 mb-6">
							<div class="col-md-12 form-password-toggle">
								<div class="form-floating form-floating-outline">
									<input
										class="form-control"
										type="password"
										id="oldPassword"
										v-model="oldPassword" />
									<label for="oldPassword">{{ $t('settings.oldPassword') }}</label>
									<small v-if="errors.oldPassword" class="text-danger">{{ errors.oldPassword }}</small>
								</div>
							</div>

							<div class="col-md-6 form-password-toggle">
								<div class="form-floating form-floating-outline">
									<input
										class="form-control"
										type="password"
										id="newPassword"
										v-model="password" />
									<label for="newPassword">{{ $t('settings.newPassword') }}</label>
									<small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
								</div>
							</div>
							<div class="col-md-6 form-password-toggle">
								<div class="form-floating form-floating-outline">
									<input
										class="form-control"
										type="password"
										id="confirmPassword"
										v-model="password2" />
									<label for="confirmPassword">{{ $t('settings.confirmPassword') }}</label>
									<small v-if="errors.password2" class="text-danger">{{ errors.password2 }}</small>
								</div>
							</div>
						</div>
						<button type="submit" class="btn btn-primary" @click="updatePassword()">{{ $t('common.actions.save') }}</button>
					</form>
				</div>
			</div>
		</div>
		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "SettingsPage",

	data() {
		return {
			profile: null,
			oldPassword: null,
			password: null,
			password2: null,
			errors: {},
		};
	},

	methods: {
		async fetchProfile() {
			try {
				const response = await HTTP("/user/profile");
				this.profile = response.data.profile;
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		validatePasswordForm() {
			this.errors = {};

			if (!this.password) {
				this.errors.password = this.$t('validation.invalidPassword');
			} else if (this.password.length < 12) {
				this.errors.password = this.$t('validation.passwordMinLength');
			} else {
				let types = 0;
				if (/[a-z]/.test(this.password)) types++;
				if (/[A-Z]/.test(this.password)) types++;
				if (/[0-9]/.test(this.password)) types++;
				if (/[^A-Za-z0-9]/.test(this.password)) types++;
				if (types < 3)
					this.errors.password = this.$t('validation.passwordComplexity');
			}

			if (!this.password2)
				this.errors.password2 = this.$t('validation.confirmPasswordInvalid');
			if (this.password && this.password2 && this.password !== this.password2)
				this.errors.password2 = this.$t('validation.passwordMismatch');

			return Object.keys(this.errors).length === 0;
		},

		async updatePassword() {
			if (!this.validatePasswordForm())
				return;

			try {
				await HTTP.post('/user/set-new-password', {
					oldPassword: this.oldPassword,
					password: this.password
				});

				this.oldPassword = "";
				this.password = "";
				this.password2 = "";

				alert(this.$t('settings.passwordUpdated'));
			} catch (error) {
				let message = this.$t('errors.cannotChangePassword');
				if (error.response?.data?.message)
					message = error.response.data.message;
				alert(message);
			}
		}
	},

	async mounted() {
		await this.fetchProfile();
	}
};
</script>
